import $ from "jquery";
import debug from "bows";

const log = debug("experts-slider");
const $es = $('.experts-slick');

function initialize_slides() {
	$es.slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToScroll: 2,
		slidesToShow: 1,
		centerMode: false,
		variableWidth: true,
		prevArrow: '.experts-btns__btn--prev',
		nextArrow: '.experts-btns__btn--next',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
					variableWidth: false
				}
			}
			// {
			// 	breakpoint: 320,
			// 	settings: {
			// 		dots: true,
			// 		infinite: true,
			// 		speed: 300,
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,

			// 		prevArrow: '.experts-btns__btn--prev',
			// 		nextArrow: '.experts-btns__btn--next',
			// 	}
			// }
		]
	});

}

export function init() {
	if ($es.length) {
		initialize_slides();
	}
}

export default {
	init
};
